module.exports = ".bordered-card{\r\n    background-color: #f1f1f1;\r\n    padding: 5px;\r\n    /* margin: 20px 0; */\r\n    -webkit-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.16),0 2px 2px 0 rgba(0,0,0,0.12)!important;\r\n            box-shadow: 0 2px 2px 0 rgba(0,0,0,0.16),0 2px 2px 0 rgba(0,0,0,0.12)!important;\r\n}\r\n.margin-top{\r\n    margin-top: 20px;\r\n}\r\n.mob-width{\r\n    width: 100%;\r\n    overflow-x: auto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/loss-data-dashboard/loss-data-dashboard.component.css
// module id = ./src/app/modules/loss-data-dashboard/loss-data-dashboard.component.css
// module chunks = main